import { Job, Readable } from 'generated/apolloComponents'
import ArticleContentWithRecommendations from '@/components/organisms/ArticleContentWithRecommendations'

interface IProps {
  readable: Readable
  className?: string
  offers?: Job[]
}

const Content = ({ readable, offers, className = '' }: IProps) => {
  if (
    readable.readableType === 'News' &&
    !readable.company &&
    offers &&
    offers.length > 0
  ) {
    return (
      <ArticleContentWithRecommendations
        readable={readable}
        recommendations={offers as Job[]}
        className={className}
      />
    )
  }

  if (readable.content) {
    return (
      <div
        className={`content text-base leading-7 md:text-2xl md:leading-9 order-1 md:order-2 ${className}`}
        dangerouslySetInnerHTML={{ __html: readable.content }}
      />
    )
  }
  return null
}

export default Content
